module.exports = __webpack_public_path__ + "static/media/Beauty.55bc3808.png";